import { ProjectFromAPI } from '../types';
import { transformProjectResponse } from './api-transforms';
import apiRequest from './apiRequest';

type ProjectCharacterPutPayload = {
  characterInstanceID: string;
  overrideCharacterID: string;
};

export default async function putProjectCharacter(
  projectID: string,
  props: ProjectCharacterPutPayload,
) {
  const { data, error } = await apiRequest<ProjectFromAPI>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/character`,
    {
      method: 'PUT',
      body: JSON.stringify(props),
    },
  );

  return {
    data: data ? transformProjectResponse(data) : undefined,
    error,
  };
}
